import { useQuery } from '@tanstack/react-query'
import { dashboardClient } from '@/api'
import { HTTPValidationError, HttpResponse, MeasureValue } from '@/api/dashboard'

type Query = {
  is_sandbox: boolean
}

/**
 * @param companyId
 * @param gameId
 * @param query
 */
export const useBalanceQuery = (companyId: string, gameId: string, query: Query = { is_sandbox: false }) => {
  return useQuery({
    queryKey: ['balance', companyId, gameId, query],
    queryFn: ({ signal }) => {
      if (import.meta.env.VITE_ENVIRONMENT == 'local') {
        return new Promise(resolve => {
          resolve({
            data: { value: 0, prev_value: 0 },
          })
        }) as unknown as Promise<HttpResponse<MeasureValue, HTTPValidationError>>
      }

      return dashboardClient.v1.getBalance({ companyId, gameId, ...query }, { signal })
    },
    select: response => response.data,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
    refetchOnMount: false,
  })
}
